<template lang="pug">
  .row(v-if="show_addons")
    .columns.large-24
        article.content-block
            header
                .title.title-with-button
                    | {{t('app.registration.addons')}}
                    button.button.right(type='submit', v-if="report_id")
                        | {{t('app.programs.save_and_continue')}}
                    .right.change-registration-section-addon(v-if="disable_block_for_family" v-html="t('app.registration.show.change_addons', {org: org_link})")
            section.content(style='padding-top:0;')
                ul.inner-list.addon-list.addons
                    li(v-for="(ra,idx) in ordered_registration_addons", :class="{disabled: disabled}")
                        keep_hidden(:obj='ra.addon', klass='addon')
                        valid_today_dates(:obj='ra.addon', klass='addon')
                        .content
                            .row
                                .columns.large-24
                                    .label-text.inline
                                        h5
                                            span.required(v-if="ra.addon.required") *
                                            | {{ra.addon.name}}
                                    div(v-if="isPresent(ra.addon.description)")
                                        WithRequired(:require="false",:text="ra.addon.description",:cut_text="true")
                                        br

                            AddonChoices(:registration_addon="ra", :addon_idx="'addon_'+idx")
                            .field(v-if="ra.addon.eligibility_required && ra.choice_ids.length > 0", style="margin-top:25px; margin-left: 25px")
                                validation-provider(v-slot="{ errors }" rules="required")
                                  .addon-eligibility(:class="{error: errors[0]}")
                                    span.required-text {{t('helpers.label.addon.this_field_is_required')}}
                                    span.required(v-if="!disabled") *
                                  FloatingLabel(:config="{label: ra.addon.eligibility_text, required: true}")
                                    input(v-model="ra.eligibility_requirement" :class="{error: errors[0]}" type="text",:placeholder="ra.addon.eligibility_text",:disabled="disabled",:required="!disabled")

</template>

<script>
  import helpers from './edit_helper'
  import WithRequired from './shared/_with_required'
  import AddonChoices from './addon/_choices.vue'
  import keep_hidden from "./_keep_hidden"
  import valid_today_dates from "./_valid_today_dates"
  import {ValidTodayAbility} from "models/concerns/valid_today_ability"
  export default {
    components: {
      WithRequired, AddonChoices,
      valid_today_dates,keep_hidden,
    },
    mixins: [helpers],
    data (){
      return {
        ordered_registration_addons: [],
      }
    },
    computed: {
      registration(){
        return this.state.current_reg
      },
      disable_block_for_family(){
        return this.registration.disable_reg_block(this.current_organization)
      },
      org_link(){
        return `<a href="/organizations/${this.state.current_reg.program.organization.slug}">${this.state.current_reg.program.organization.name}</a>`
      },
      // (current_organization.blank? && registration.program.addons.any?{|addon| addon.valid_today? && !addon.keep_hidden}) || (current_organization && registration.program.addons.any?)
      show_addons(){
        if (this.current_organization.id){
          return this.registration.program.addons.length > 0
        }else{
          return this.registration.program.addons.some((addon)=> {
            const ability = new ValidTodayAbility(addon)
            return ability.valid_today() && !addon.keep_hidden
          })
        }
      },
      disabled(){ return this.disable_block_for_family },
      report_id(){
        return this.$route.query.report_id;
      }
    },
    created(){
      try{
        let addon_ids = this.registration.program.addon_ids
        this.ordered_registration_addons = this.registration.registration_addons.sort((a,b)=> addon_ids.indexOf(a.addon_id) - addon_ids.indexOf(b.addon_id) )
      }catch (e) {
        this.ordered_registration_addons = this.registration.registration_addons
      }
    },
  }
</script>

<style scoped>

</style>
